import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/siteData";

export default function WhatsAppButton() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  const text = encodeURIComponent("Hello Wisdom Insurance, I would like to discuss an insurance requirement.");
  return (
    <a
      data-testid="whatsapp-float-button"
      href={`https://wa.me/${COMPANY.whatsappNumber}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 rounded-full bg-[#25D366] p-4 shadow-xl shadow-emerald-900/25 transition-all duration-300 hover:shadow-2xl hover:shadow-emerald-900/35"
    >
      <MessageCircle className="h-6 w-6 text-white" />
      <span className="max-w-0 overflow-hidden text-sm font-semibold text-white transition-all duration-300 group-hover:ml-2 group-hover:max-w-[120px]">
        Chat with us
      </span>
    </a>
  );
}
